module.exports = __webpack_public_path__ + "img/icon_youtube_outline.c3750546.svg";